import { createFileRoute, redirect } from "@tanstack/react-router";
import { getRecordScopedAssetWorkspacePath } from "@/features/records/lib/get-record-scoped-asset-path.util";

export const Route = createFileRoute(
	"/_authenticated/(web-app)/_web/web/$orgId/records/(record)/$recordId/workspace/assets/$assetId/workspace/",
)({
	beforeLoad: ({ params }) => {
		throw redirect({
			href: getRecordScopedAssetWorkspacePath({
				orgId: params.orgId,
				recordId: params.recordId,
				assetId: params.assetId,
				tab: "form",
			}),
		});
	},
});
